import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contest-form__group bs-row" }
const _hoisted_2 = { class: "ds-input-old ds-input-old--text c-12 c-sm-6" }
const _hoisted_3 = { class: "ds-input-old__wrapper" }
const _hoisted_4 = { class: "ds-input-old ds-input-old--text c-12 c-sm-6" }
const _hoisted_5 = { class: "ds-input-old__wrapper" }
const _hoisted_6 = { class: "ds-input-old ds-input-old--tel c-12 c-sm-6" }
const _hoisted_7 = {
  class: "ds-input-old__label",
  for: "form-phone"
}
const _hoisted_8 = {
  key: 0,
  class: "contest-form__required-marker"
}
const _hoisted_9 = { class: "ds-input-old__wrapper" }
const _hoisted_10 = ["required"]
const _hoisted_11 = { class: "ds-input-old__icon ds-input-old__icon--flag-cz-rectangle" }
const _hoisted_12 = { class: "ds-input-old ds-input-old--text c-12 c-sm-6" }
const _hoisted_13 = {
  class: "ds-input-old__label",
  for: "form-email"
}
const _hoisted_14 = {
  key: 0,
  class: "contest-form__required-marker"
}
const _hoisted_15 = { class: "ds-input-old__wrapper" }
const _hoisted_16 = ["required"]
const _hoisted_17 = { class: "contest-form__group bs-row" }
const _hoisted_18 = { class: "ds-input-old ds-input-old--checkbox c-12 c-sm2-6" }
const _hoisted_19 = { class: "ds-checkbox-old" }
const _hoisted_20 = { class: "ds-checkbox-old__inner-text-wrap contest-form__required-wrapper" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "contest-form__group bs-row" }
const _hoisted_23 = { class: "ds-input-old ds-input-old--textarea c-12" }
const _hoisted_24 = {
  class: "ds-input-old__label contest-form__required-wrapper",
  for: "form-text"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "ds-input-old__wrapper" }
const _hoisted_27 = {
  key: 0,
  class: "contest-form__error"
}
const _hoisted_28 = { class: "contest-form__button" }

import { getCurrentInstance, nextTick, onMounted, ref } from "vue";
import { vMaska } from "maska/vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import { Loader } from "@sazka/design-system/src/loader/loader";
import { showAlert } from "@sazka/design-system/src/modal-alert/mount-alert";
import { triggerMobileAppEvent } from "@sazka/mobile-apps/mobile-app-integration";
import { httpClient } from "@sazka/utils/http-clients/http-client";
import { ContestFormData, ContestFormConfiguration } from "../models/contest-form-models";


export default /*@__PURE__*/_defineComponent({
  __name: 'contest-form',
  props: {
    configuration: {},
    identifier: {}
  },
  setup(__props: any) {

const props = __props;

const app = getCurrentInstance();

const formErrorMessage = ref<string>("");
const formData = ref<ContestFormData>({} as ContestFormData);
const isModalVisible = ref(false);

const handleRulesClick = (e: Event) => {
    const clickLink = e.target?.["href"];
    if (clickLink && environment.isInAppView) {
        e.preventDefault();
        triggerMobileAppEvent("openPdf", clickLink);
    }
};

const closeModal = () => {
    nextTick(() => {
        app?.appContext.app.unmount();
    });
};

const validateForm = () => {
    if (
        !formData.value.firstName ||
        !formData.value.lastName ||
        (props.configuration.isPhoneRequired && !formData.value.phone) ||
        (props.configuration.isEmailRequired && !formData.value.email) ||
        !formData.value.hasAgreed ||
        !formData.value.text
    ) {
        formErrorMessage.value = "Jejda, odeslání se nepodařilo. Musíte vyplnit všechna povinná pole.";
        return false;
    } else {
        formErrorMessage.value = "";
        return true;
    }
};

const submitForm = async () => {
    if (!validateForm()) {
        return;
    }

    Loader.show();

    try {
        await httpClient.post("/api/landing-page/contest-form", formData.value, {
            params: {
                identifier: props.identifier,
            },
        });
        formData.value = {} as ContestFormData;
        closeModal();
        showAlert({
            title: "Byli jste zařazeni do soutěže",
            subText: "Děkujeme za vaši registraci! Výherce budeme brzy kontaktovat na zadané kontaktní údaje.",
            btnCloseText: "Rozumím",
            alertImageSrc: "/img/registration/kulicnik-check.png",
        });
    } catch {
        showAlert({
            title: "Odeslání se nezdařilo, zkuste to prosím později.",
            btnCloseText: "Rozumím",
        });
    } finally {
        Loader.hide();
    }
};

onMounted(() => {
    isModalVisible.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsModalDialog, {
    modelValue: isModalVisible.value,
    "onUpdate:modelValue": [
      _cache[6] || (_cache[6] = ($event: any) => ((isModalVisible).value = $event)),
      closeModal
    ]
  }, {
    top: _withCtx(() => [
      _createVNode(DsTopSlotHeadlineSubheadline, { headline: "Vyplňte své kontaktní údaje" })
    ]),
    content: _withCtx(() => [
      _createElementVNode("form", {
        class: "contest-form",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              class: "ds-input-old__label",
              for: "form-first-name"
            }, [
              _createTextVNode("Jméno"),
              _createElementVNode("span", { class: "contest-form__required-marker" }, " *")
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("input", {
                required: "",
                type: "text",
                class: "ds-input-old__input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.firstName) = $event)),
                name: "form-first-name",
                id: "form-first-name",
                autocomplete: "given-name",
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  formData.value.firstName,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              class: "ds-input-old__label",
              for: "form-last-name"
            }, [
              _createTextVNode("Příjmení"),
              _createElementVNode("span", { class: "contest-form__required-marker" }, " *")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                required: "",
                type: "text",
                class: "ds-input-old__input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.lastName) = $event)),
                name: "form-last-name",
                id: "form-last-name",
                autocomplete: "family-name",
                maxlength: "100"
              }, null, 512), [
                [
                  _vModelText,
                  formData.value.lastName,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _cache[9] || (_cache[9] = _createTextVNode("Telefonní číslo ")),
              (_ctx.configuration.isPhoneRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " *"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                required: _ctx.configuration.isPhoneRequired,
                type: "tel",
                class: "ds-input-old__input--icon ds-input-old__input telephone",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.phone) = $event)),
                name: "form-phone",
                id: "form-phone",
                maxlength: "9"
              }, null, 8, _hoisted_10), [
                [
                  _vModelText,
                  formData.value.phone,
                  void 0,
                  { trim: true }
                ],
                [_unref(vMaska), '#########']
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(DsIcon, {
                  name: "flag-cz-rectangle",
                  width: 24,
                  height: 24
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, [
              _cache[10] || (_cache[10] = _createTextVNode("E-mail ")),
              (_ctx.configuration.isEmailRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " *"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                required: _ctx.configuration.isEmailRequired,
                type: "email",
                class: "ds-input-old__input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.email) = $event)),
                name: "form-email",
                id: "form-email",
                maxlength: "320"
              }, null, 8, _hoisted_16), [
                [
                  _vModelText,
                  formData.value.email,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                required: "",
                type: "checkbox",
                class: "ds-checkbox-old__inp",
                name: "form-agreement",
                id: "form-agreement",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.hasAgreed) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.value.hasAgreed]
              ]),
              _createVNode(DsIcon, {
                name: "check",
                class: "ds-checkbox-old__check"
              }),
              _createElementVNode("span", _hoisted_20, [
                _createElementVNode("span", {
                  onClick: handleRulesClick,
                  class: "ds-checkbox-old__text",
                  innerHTML: _ctx.configuration.agreementText
                }, null, 8, _hoisted_21),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "contest-form__required-marker" }, " *", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, [
              _createElementVNode("span", {
                innerHTML: _ctx.configuration.questionText
              }, null, 8, _hoisted_25),
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "contest-form__required-marker" }, " *", -1))
            ]),
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("textarea", {
                required: "",
                type: "text",
                class: "ds-input-old__input",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.text) = $event)),
                name: "form-text",
                id: "form-text"
              }, null, 512), [
                [
                  _vModelText,
                  formData.value.text,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        (formErrorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(formErrorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "ds-divider ds-modal-dialog__bottom-divider" }, null, -1)),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(DsButton, { "html-type": "submit" }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("Odeslat")
            ])),
            _: 1,
            __: [13]
          })
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})